export default {
    Home: "/",

    // User
    UserProfile: "/user",
    BusinessInformation: "/bedrift/informasjon",
    BusinessOrders: "/bedrift/ordre",
    BusinessUsers: "/bedrift/brukere",
    BusinessRegistration: "/bedrift/registrering",
    PurchaseHistory: "/user/purchases",
    Savings: "/user/savings",
    PurchaseComplaint: "/user/purchases/complaint",
    Help: "/user/help",
    ContactDetails: "/user/contact-details",
    TrumfProfile: "/user/settings/trumf-profile",
    TrumfMember: "/user/settings/trumf-profile/personopplysninger",
    TrumfBankCards: "/user/settings/trumf-profile/kort-konto",
    TrumfTrumfCards: "/user/settings/trumf-profile/trumf-kort",
    TrumfChainConsents: "/user/settings/trumf-profile/samtykker",
    TrumfAnalyticalConsent: "/user/settings/trumf-profile/personalisering",
    TrumfAssociates: "/user/settings/trumf-profile/felles-medlemskap",
    UserManageBiometrics: "/user/settings/manage-biometrics",
    NotificationSettings: "/user/settings/notifications",
    CookieConsent: "/user/settings/cookie-consent",
    DinnerSuggestionsPreferences: "/user/settings/dinner-suggestions-preferences",
    OrderItem: "/user/orders/:id",
    OrderHistory: "/user/orders",
    CustomerServicePage: "/user/customer-service",
    UseBonus: "/user/use-bonus",
    UseCoupons: "/user/use-coupons",
    UseBonusToCharity: "/user/use-bonus-charity",
    UseBonusToBank: "/user/use-bonus-bank",

    // Products
    Search: "/search",
    Products: "/products",
    ProductPage: "/product",
    Category: "/products/:category1/:category2?/:category3?/:category4?",

    // Cart and Checkout
    Cart: "/cart",
    Checkout: "/cart/checkout",

    // Savings
    Campaign: "/savings/campaigns/:id",

    // Gode kjøp
    BestBuy: "/bestbuy",

    // Recipes
    RecipesHome: "/recipes",
    MyRecipes: "/recipes/mine",
    // RecipePage: "/recipes/recipe/:recipeId",
    // StoredRecipes: "/recipes/stored-recipes",

    // Shopping Lists
    ShoppingListsHome: "/shopping-lists",
    ShoppingListPage: "/shopping-lists/:id",

    // Diet Insight
    DietHome: "/insight",
    DietOverview: "/insight/diet/overview",
    DietMacroNutrients: "/insight/diet/macro",
    DietLevelOne: "/insight/diet/level-one",
    DietLevelTwo: "/insight/diet/level-two",
    DietLevelThree: "/insight/diet/level-three",
    DietLevelFour: "/insight/diet/level-four",

    // Climate Insight
    ClimateHome: "/insight/climate",
    ClimateProductGroups: "/insight/climate/product-groups",
    ClimateLevelTwo: "/insight/climate/level-two",
    ClimateLevelThree: "/insight/climate/level-three",

    // Debug
    Debug: "/debug",
    AccessibilityPlayground: "/accessibility-playground",
    LoggerPlayground: "/logger-playground",
    ComponentPlayground: "/component-playground",
    ChatPage: "/chat-page",

    // Loyalty Club
    Benefits: "/loyalty-club/benefits",
}
